import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, AlertController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";
import { ImageBrowserUploadProvider } from '../../providers/image-browser-upload/image-browser-upload';

import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { VisitorsRegMorePage } from '../visitors-reg-more/visitors-reg-more';
import { LoginPage } from '../login/login';
import { CalendarPage } from '../calendar/calendar';
import { VideoPage } from '../video/video';
import { DirectionsPage } from '../directions/directions';
import { SecurityhomePage } from '../securityhome/securityhome';
import { CheckinPage } from '../checkin/checkin';

declare var cordova: any;

//@IonicPage()
@Component({
  selector: 'page-viewvisitor',
  templateUrl: 'viewvisitor.html',
})
export class ViewvisitorPage {

  //imgPreview = '../../assets/imgs/upload.jpeg';

  
  private visitor_view : FormGroup;
  lastImage: string = null;
  loading: Loading;

  confirmPass:boolean = false;
  isparking:boolean = false;
  iswifi:boolean = false;
  iswheelChair:boolean = false;
  items:any;

  disclaimer = false;
 

  imgPreview = '../../assets/imgs/upload.jpeg';
  regData = { avatar:'', name: '', surname: '', id_passport: '', email: '',mnumber: '', carreg:'', carmodel:'', carmake:'', company:'' };
  title = "Mr";
  fname = "";
  surname = "";
  id_type = "ID";
  id_passport = "";
  mnumber = "";
  numberOnly = "";
  email = "";
  password = "";
  cpassword = "";
  carreg = "";
  carmodel = "";
  carmake = "";
  company = "";
  parkingCheckBox = "";
  submitting = false;

  
  passtype = "password";
  showPass = false;

  datas = "";//[];
  registration = "";
  model = "";
  name = "";
  photoLocation = "";

  accessCode = "";
  authtoken = "";

  queAns = false;
  isloading = true;
  error = false;

  acccode = "";
  viscode = "";
  idNumber = "";

  security = false;
  reception = false;

  /**  */
  checkedIn = false;
  checkedOut = false;

  issueBadge = false;
  issueBadgeRet = false;

  
  /** browser upload variable */
  browser = true;
  public image : string = '../../assets/imgs/upload.jpeg';
  public isSelected : boolean 		=	false;
  private _SUFFIX : string;
  public upFileNm : string = '';

  public imgdata : string = '';
  

  




  constructor( 
      private formBuilder: FormBuilder,  
      public navCtrl: NavController, 
      private toastCtrl: ToastController, 
      public navParams: NavParams,     
      public http: HttpClient,    
      private imagePicker: ImagePicker,    
      private base64: Base64,
      private camera: Camera, 
      private transfer: Transfer, 
      private file: File, 
      private filePath: FilePath, 
      public actionSheetCtrl: ActionSheetController, 
      public platform: Platform, 
      public loadingCtrl: LoadingController ,
      private _ALERT     : AlertController,
      private _IMAGES 		: ImageBrowserUploadProvider,
      private storage: Storage,
      public global: GlobalProvider
    ) {

      if (this.platform.is('windows') || this.platform.is('android') || this.platform.is('ios')) {
        this.browser = false;
      }else if (this.platform.is('core') || this.platform.is('mobileweb')) {
        this.browser = true;
      }

      
      this.acccode = this.navParams.get('viscode');

      this.visitor_view = this.formBuilder.group({
        title: [null],//['', Validators.required],
        fname: ["", Validators.required],//, Validators.pattern('[a-zA-Z ]*')],
        surname: ["", Validators.required],
        id_passport: ["",Validators.compose([
                          Validators.required,
                          Validators.pattern('^[a-zA-Z0-9_.+-]+$')
                        ])
                      ],
        mnumber: ["", Validators.pattern('[0-9]{9}')],
        email: ["",Validators.compose([
                    Validators.required,
                    Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
                  ])],
        carreg: [null],//'',//['', Validators.required],
        carmodel: [null],//'',//['', Validators.required],
        carmake: [null],//'',//['', Validators.required],
        company: [null]//['', Validators.required]
  
      });

      this.storage.get('accesscode').then((val) => {
        //console.log('acc = '+val);
        this.accessCode = val;
        this.storage.get('Authorization').then((val1) => {
          this.authtoken = val1;
          //console.log('auth = '+this.authtoken);
          this.viscode = this.navParams.get('viscode');
          this.storage.get('userrole').then((val2) => {
            if(val2 == 'ROLE_RECEPTION'){
              this.security = false;
              this.reception = true;
              this.getVisitorInfo();
  
            }else if(val2 == 'ROLE_SECURITY'){
              this.security = true;
              this.reception = false;
              this.getVisitorInfo();
  
            }
            
            
          });
          
        });
        
      });
      
    
  }

  regForm(){
    //this.submitting = true;

    
    //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=true;
    
    //this.navCtrl.push(VisitorsRegMorePage);

    
    /*let header = new HttpHeaders({
      "Accept":'application/json',
      'Content-Type':'application/json'
    });*/
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };
    //const requestOpt = new RequestOptions({ headers: header });
    var photoLink = ""
    if(this.imgPreview == '../../assets/imgs/upload.jpeg'){
      photoLink = "";
    }else{
      if(this.browser == true){
        photoLink = this.image;
      }else if(this.browser == false){
        photoLink = this.imgPreview;
      }
      
    }

    
    let postData = JSON.stringify({
      
      "updateVisitorDTO": {
        "captureType": "visitor",
        "cars": [
          {
            "make": this.carmake,
            "model": this.carmodel,
            "registration": this.carreg
          }
        ],

        "company": this.company,
        "disclaimer": true,
        "email": this.email,
        "idNumber": this.id_passport,
        "identityType": this.id_type,
        "licenseNumber": this.id_passport,
        "name": this.name,
        //"parking": this.isparking,
        "passport": this.id_passport,
        "phones": [
          {
            "number": this.mnumber
          }
        ],
        "image":this.imgdata,
        "photoLocation": photoLink,
        "surname": this.surname,
        //"wheelChair": this.iswheelChair,
        //"wifi": this.iswifi,
        "title": this.title,
        "verificationCode":this.acccode
      }
    
    });

    
  
  
    
    
    /*this.vistor_reg.value/*{
      "name": "Customer004",
      "email": "customer004@email.com",
      "mnumber": "0000252525"
    }*/

    this.http.put(this.global.baseUrl+"api/register", postData, httpOptions)
      .subscribe((data:any) => {
        console.log(data['_body']);
        console.log(data);
        console.log(data.error);
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 20000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=false;
            this.disclaimer = false;
            
          }else{
            let toast = this.toastCtrl.create({
              message: 'Visitor updated successfully!.',
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=false;
            //this.navCtrl.push(HomePage);
            this.disclaimer = false;
            this.submitting = false;
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 3000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        this.disclaimer = false;
        this.submitting = false;
    });
  }

  logout(){
    this.storage.clear();
    this.navCtrl.push(LoginPage);
  }

  goback(){
    this.navCtrl.pop();
  }

  redirectPage(params:string){
    console.log('params pa = '+params);
    if(params == 'SecurityhomePage')
      this.navCtrl.push(SecurityhomePage);
    else if(params == 'CheckinPage')
      this.navCtrl.push(CheckinPage, {
        viscode:this.viscode 
      });
    else if(params == 'VideoPage')
      this.navCtrl.push(VideoPage);
    else if(params == 'DirectionsPage')
      this.navCtrl.push(DirectionsPage);

  }

  checkin(){
    //(<HTMLInputElement> document.getElementById('checkIn')).disabled=true;
    this.storage.get('Authorization').then((val1) => {
      this.authtoken = val1;
    });

    let httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };
/*
    let postData = JSON.stringify({
      "checkinDTO": {
        "declaration": [
          this.declaration
        ],
        "personVisited": this.visited,
        "productSerial": [
          this.prodsno
        ],
        "reasonForVisit": [
          this.reason
        ],
        "verificationCode": this.viscode
      }
    });
*/
    let postData = JSON.stringify({
      "verificationCode": this.viscode
    });
    //console.log(httpOptions);
    
    this.http.post(this.global.baseUrl+"api/admin/checkin?verificationCode="+this.viscode, httpOptions)
      .subscribe((data:any) => {
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            (<HTMLInputElement> document.getElementById('checkInBtn')).disabled=false;
            
          }else{
            console.log(data.visitorDTO);
            let toast = this.toastCtrl.create({
              message: 'Check-In added successfully',
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();

            
            this.checkedIn = data.event.checkedIn;
            this.checkedOut = data.event.checkedOut;
            this.issueBadge = data.event.issueBadge;
            this.issueBadgeRet = data.event.returnBadge;
            (<HTMLInputElement> document.getElementById('checkInBtn')).disabled=true;
            
            //this.navCtrl.push(SecurityhomePage);
          }
        }, error => {
          console.log(error);
          let toast = this.toastCtrl.create({
            message: 'Error!.',
            duration: 5000,
            position: 'bottom',
            showCloseButton:false,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();
          (<HTMLInputElement> document.getElementById('checkInBtn')).disabled=false;
          
      });
  }

  checkout(){
    let httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    let url = this.global.baseUrl+"api/admin/checkout?verificationCode="+this.viscode;

    

    this.http.post(url, httpOptions)//requestOpt)
      .subscribe((data:any) => {
          if(data.error == true){
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
          }else{
            console.log(data.visitorDTO);
            let toast = this.toastCtrl.create({
              message: "Visitor Checked-out successfully.",
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            this.navCtrl.push(SecurityhomePage);
          }
        }, error => {
          console.log(error);
          let toast = this.toastCtrl.create({
            message: 'Error!.',
            duration: 5000,
            position: 'bottom',
            showCloseButton:false,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();
          
      });
  }

  badgeIss(){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    let url = this.global.baseUrl+"api/admin/badge/issue?verificationCode="+this.viscode;

    this.http.post(url, httpOptions)//requestOpt)
      .subscribe((data:any) => {
          if(data.error == true){
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
          }else{
            console.log(data.visitorDTO);
            let toast = this.toastCtrl.create({
              message: "Badge Issued successfully!.",
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            this.navCtrl.push(SecurityhomePage);
          }
        }, error => {
          console.log(error);
          let toast = this.toastCtrl.create({
            message: 'Error!.',
            duration: 5000,
            position: 'bottom',
            showCloseButton:false,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();

          
      });
  }

  badgeRet(){
    let httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    let url = this.global.baseUrl+"api/admin/badge/return?verificationCode="+this.viscode;

    

    this.http.post(url, httpOptions)//requestOpt)
      .subscribe((data:any) => {
          if(data.error == true){
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
          }else{
            console.log(data.visitorDTO);
            let toast = this.toastCtrl.create({
              message: "Badge returned successfully!.",
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            this.navCtrl.push(SecurityhomePage);
          }
        }, error => {
          console.log(error);
          let toast = this.toastCtrl.create({
            message: 'Error!.',
            duration: 5000,
            position: 'bottom',
            showCloseButton:false,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();
          
      });
  }
  /** regiasteration upload */
  getVisitorInfo(){

    
    
    let httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    let url = this.global.baseUrl+"api/admin/visitor?verificationCode="+this.viscode;

    

    this.http.get(url, httpOptions)//requestOpt)
      .subscribe((data:any) => {
        
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){
                //this.storage.clear();
                //this.navCtrl.push(LoginPage);
              }
              console.log('Dismissed toast!');
            });
          
            toast.present();
          }else{
            console.log(data.visitorDTO);
            this.datas = data.visitorDTO;
            /*
            this.visitor_view.controls['name'].setValue(data.visitorDTO.name);
           this.visitor_view.controls['surname'].setValue(data.visitorDTO.surname);
           this.visitor_view.controls['id_passport'].setValue(data.visitorDTO.idNumber);
           this.visitor_view.controls['mnumber'].setValue(data.visitorDTO.phones[0].number);
           this.visitor_view.controls['email'].setValue(data.visitorDTO.email);
           this.visitor_view.controls['carreg'].setValue(data.visitorDTO.cars[0].registration);
           this.visitor_view.controls['carmodel'].setValue(data.visitorDTO.cars[0].model);
           this.visitor_view.controls['company'].setValue(data.visitorDTO.company);*/
           
           if(data.visitorDTO.image == ""){
            this.imgPreview = '';//'data:image/jpeg;base64,'+data.visitorDTO.image;
            this.image = '';//'data:image/jpeg;base64,'+data.visitorDTO.image;
            
           }else{
            this.imgPreview = 'data:image/jpeg;base64,'+data.visitorDTO.image;
            this.image = 'data:image/jpeg;base64,'+data.visitorDTO.image;
           }
           this.imgdata = data.visitorDTO.image;
           //this.imgPreview = data.visitorDTO.photoLocation;
           //this.image = data.visitorDTO.photoLocation;

           //this.title = data.visitorDTO.title;
           this.id_type = "ID";
           
            this.title = data.visitorDTO.title;
            this.name = data.visitorDTO.name;
            this.fname = data.visitorDTO.name;
            this.surname = data.visitorDTO.surname;
            this.email = data.visitorDTO.email;
            this.id_passport = data.visitorDTO.idNumber;
            this.company = data.visitorDTO.company;

            

            


            this.queAns = data.visitorDTO.answered;
            this.mnumber = data.visitorDTO.phones[0].number;
            //this.numberOnly = data.visitorDTO.phones[0].number;
            //this.imgPreview = data.visitorDTO.photoLocation;
            //this.image = data.visitorDTO.photoLocation;
            //console.log('car len = '+data.visitorDTO.cars.length);
            if(data.visitorDTO.cars.length != 0){
              this.carmodel = data.visitorDTO.cars[0].model;
              this.carreg = data.visitorDTO.cars[0].registration;
              this.carmake = data.visitorDTO.cars[0].make;
            }else{
              //this.registration = "";
              //this.model = "";
              this.carmodel = "";
              this.carreg = ""; 
              this.carmake = ""; 
            }
            
            this.storage.set('usermail',data.visitorDTO.email);

            this.visitInfo();
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 5000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        
    });
  }

  

  visitInfo(){
    let httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    let url = this.global.baseUrl+"api/admin/event?verificationCode="+this.viscode;

    

    this.http.get(url, httpOptions)//requestOpt)
      .subscribe((data:any) => {
        
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){
                
              }
              console.log('Dismissed toast!');
            });
          
            toast.present();
          }else{
            console.log(data.visitorDTO);
            if(data.event ==  null){
              this.checkedIn = false;
              this.checkedOut = true;
              this.issueBadge = false;
              this.issueBadgeRet = false;
            }else if(data.event.checkedIn == true && data.event.checkedOut == true){
              this.checkedIn = false;
              this.checkedOut = data.event.checkedOut;
              this.issueBadge = false;
              this.issueBadgeRet = false;
            }else{
              this.checkedIn = data.event.checkedIn;
              this.checkedOut = data.event.checkedOut;
              this.issueBadge = data.event.issueBadge;
              this.issueBadgeRet = data.event.returnBadge;
            }/*else if(data.event.checkedIn == true && data.event.issueBadge == false && data.event.returnBadge == false && data.event.checkedOut == false){
              this.checkedIn = true;
              this.checkedOut = false;
              this.issueBadge = false;
              this.issueBadgeRet = false;
            }else if(data.event.checkedIn == true && data.event.issueBadge == true && data.event.returnBadge == false && data.event.checkedOut == false){
              this.checkedIn = true;
              this.issueBadge = true;
              this.issueBadgeRet = false;
              this.checkedOut = false;
            }else if(data.event.checkedIn == true && data.event.issueBadge == true && data.event.returnBadge == true && data.event.checkedOut == false){
              this.checkedIn = true;
              this.issueBadge = true;
              this.issueBadgeRet = true;
              this.checkedOut = false;
            }else if(data.event.checkedIn == true && data.event.issueBadge == true && data.event.returnBadge == true && data.event.checkedOut == true){
              this.checkedIn = false;
              this.issueBadge = true;
              this.issueBadgeRet = true;
              this.checkedOut = true;
            }else if(data.event.checkedIn == true && data.event.issueBadge == false && data.event.returnBadge == false && data.event.checkedOut == false){
              this.checkedIn = true;
              this.issueBadge = true;
              this.issueBadgeRet = false;
              this.checkedOut = true;
            }else if(data.event.checkedIn == true && data.event.issueBadge == true && data.event.returnBadge == false && data.event.checkedOut == false){
              this.checkedIn = true;
              this.issueBadge = true;
              this.issueBadgeRet = false;
              this.checkedOut = false;
            }*/

            
           
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 5000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        
    });
  }


  /** image upload app */
  
  /** image upload */
  public presentActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Select Image Source',
      buttons: [
        {
          text: 'Load from Library',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: 'Use Camera',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  public takePicture(sourceType) {
    // Create options for the Camera Dialog
    var options = {
      quality: 20,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,//FILE_URI,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };
   
    // Get the data of an image
    this.camera.getPicture(options).then((imagePath) => {
      // Special handling for Android library
      this.imgPreview = 'data:image/jpeg;base64,' + imagePath;
      this.imgdata = imagePath;
  
      //this.loading.dismissAll()
      this.presentToast('Image succesfully uploaded.');
      this.regForm();
      /*
      if (this.platform.is('android') && sourceType === this.camera.PictureSourceType.PHOTOLIBRARY) {
        this.filePath.resolveNativePath(imagePath)
          .then(filePath => {
            let correctPath = filePath.substr(0, filePath.lastIndexOf('/') + 1);
            let currentName = imagePath.substring(imagePath.lastIndexOf('/') + 1, imagePath.lastIndexOf('?'));
            this.copyFileToLocalDir(correctPath, currentName, this.createFileName());
          });
      } else {
        var currentName = imagePath.substr(imagePath.lastIndexOf('/') + 1);
        var correctPath = imagePath.substr(0, imagePath.lastIndexOf('/') + 1);
        this.copyFileToLocalDir(correctPath, currentName, this.createFileName());
      }
      */
    }, (err) => {
      this.presentToast('Error while selecting image.');
    });
  }

  // Create a new name for the image
  private createFileName() {
    var d = new Date(),
    n = d.getTime(),
    newFileName =  n + ".jpg";
    return newFileName;
  }
  
  // Copy the image to a local folder
  private copyFileToLocalDir(namePath, currentName, newFileName) {
    this.file.copyFile(namePath, currentName, cordova.file.dataDirectory, newFileName).then(success => {
      this.lastImage = newFileName;
      this.uploadImage();
    }, error => {
      this.presentToast('Error while storing file.');
    });
  }
  
  private presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
  
  // Always get the accurate path to your apps folder
  public pathForImage(img) {
    if (img === null) {
      return '';
    } else {
      return cordova.file.dataDirectory + img;
    }
  }

  public uploadImage() {
    // Destination URL
    var url = this.global.uploadUrl+"upload.php";//"http://192.168.1.34/upload/upload.php";
   
    // File for Upload
    var targetPath = this.pathForImage(this.lastImage);
   
    // File name only
    var filename = this.lastImage;
   
    var options = {
      fileKey: "file",
      fileName: filename,
      chunkedMode: false,
      mimeType: "multipart/form-data",
      params : {'fileName': filename}
    };
   
    const fileTransfer: TransferObject = this.transfer.create();
   
    this.loading = this.loadingCtrl.create({
      content: 'Uploading...',
    });
    this.loading.present();
   
    // Use the FileTransfer to upload the image
    fileTransfer.upload(targetPath, url, options).then(data => {
      this.loading.dismissAll()
      this.presentToast('Image succesful uploaded.');
      console.log('image success data');
      console.log(data);
      console.log('path : '+targetPath);
      console.log('file name : '+filename);
      this.imgPreview = this.global.uploadUrl+"uploads/"+filename;
      this.image = this.global.uploadUrl+"uploads/"+filename;
      
      this.photoLocation = this.global.uploadUrl+"uploads/"+filename;

      this.regForm();

    }, err => {
      this.loading.dismissAll()
      this.presentToast('Error while uploading file.');
      console.log(err);
    });
  }

  /** browser upload */

  /** browser upload */

  /**
    * @public
    * @method selectFileToUpload
    * @param event  {any}     	The DOM event that we are capturing from the File input field
    * @description    			Handles the selection of image files from the user's computer,
    *                 			validates they are of the correct file type and displays the
    *							selected image in the component template along with an upload
    * 							button
    * @return {none}
    */
   selectFileToUpload(event) : void
   {
    this.loading = this.loadingCtrl.create({
      content: 'Uploading...',
    });
    this.loading.present();
      this._IMAGES
      .handleImageSelection(event)
      .subscribe((res) =>
      {

         // Retrieve the file type from the base64 data URI string
         this._SUFFIX 			= res.split(':')[1].split('/')[1].split(";")[0];


         // Do we have correct file type?
         if(this._IMAGES.isCorrectFileType(this._SUFFIX))
         {

            // Hide the file input field, display the image in the component template
            // and display an upload button
            this.isSelected 	= true
            this.image 			= res;
            this.imgPreview = res;
            var splitted = res.split(",").pop(); 
            this.imgdata = splitted;
            //console.log(splitted);
            //this.upFileNm = 'brw_'+Date.now();
            //console.log('---------*******-------');
            //console.log(this.imgPreview)
            this.loading.dismissAll()
            this.presentToast('Image succesfully uploaded.');
            this.regForm();
            //this.upFileNm = 'brw_'+Date.now();
            //this.uploadFile();
         }

         // If we don't alert the user
         else
         {
            this.displayAlert('You need to select an image file with one of the following types: jpg, gif or png');
            this.loading.dismissAll()
         }
      },
      (error) =>
      {
         console.dir(error);
         //this.displayAlert(error.message);
         
         this.loading.dismissAll()
         this.presentToast('Error while uploading file.');
      });
   }




   /**
    * @public
    * @method uploadFile
    * @description    			Handles uploading the selected image to the remote PHP script
    * @return {none}
    */
   uploadFile() : void
   {
      this._IMAGES
      .uploadImageSelection(this.image,
                            this._SUFFIX,
                            this.upFileNm)
      .subscribe((res) =>
      {
         //this.displayAlert(res.message);
         console.log(res.path);
         this.imgPreview = res.path;
         this.image = res.path;
         
         this.loading.dismissAll()
         this.presentToast('Image succesfully uploaded.');
         this.regForm();
         /*
          const httpOpt = {
            headers: new HttpHeaders({
              'Content-Type':  '/*',
              'Accept': '/*'
            })
          };
          let imgData = JSON.stringify({
            "file": res.path//base64File
          });
          this.http.post(this.global.baseUrl+"api/photo/upload", imgData, httpOpt)//requestOpt)
          .subscribe(data => {
              console.log(data['_body']);
              this.loading.dismissAll()
              this.presentToast('Image succesful uploaded.');
          }, error => {
              console.log(error);
              this.loading.dismissAll()
              this.presentToast('Error while uploading file.');
              console.log(error);
          });*/
      },
      (error : any) =>
      {
         console.dir(error);
         this.displayAlert(error.message);
         this.loading.dismissAll()
      });
   }




   /**
    * @public
    * @method displayAlert
    * @param message  {string}  The message to be displayed to the user
    * @description    			Use the Ionic AlertController API to provide user feedback
    * @return {none}
    */
   displayAlert(message : string) : void
   {
      let alert : any   = this._ALERT.create({
         title 		: 'Heads up!',
         subTitle 	: message,
         buttons 	: ['Got it']
      });
      alert.present();
   }

}



// WEBPACK FOOTER //
// ./src/pages/viewvisitor/viewvisitor.ts